import { AuthResponseDto, LoginDto } from "@resume-studio/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";

import { ADMIN_USER_KEY } from "../../constants/query-keys";
import { axios } from "../../libs/axios";
import { queryClient } from "../../libs/query-client";
import { useAuthStore } from "../../stores/auth";

export const adminLogin = async (data: LoginDto) => {
  const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, LoginDto>(
    "/admin/auth/login",
    data,
  );

  return response.data;
};

export const useAdminLogin = () => {
  const navigate = useNavigate();
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: loginFn,
  } = useMutation({
    mutationFn: adminLogin,
    onSuccess: (data) => {
      // Server says "we accepted your password but you still owe us OTP" — we
      // navigate to the dedicated admin OTP page (which lives at
      // /verify-otp on the admin subdomain, NOT under /auth/* like the
      // consumer app).
      if (data.status === "2fa_required") {
        navigate("/verify-otp");
        return;
      }

      setUser(data.user);
      queryClient.setQueryData(ADMIN_USER_KEY, data.user);
    },
  });

  return { login: loginFn, loading, error };
};
